export const PlayIcon = ({ width = 10, height = 10, color = 'white', ...props }: JSX.IntrinsicElements['svg']) => (
  <svg width={width} height={height} viewBox='0 0 10 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g opacity='0.6'>
      <path
        d='M6.91406 4.54883L1.47656 1.3125C1.41016 1.27344 1.3418 1.25 1.26367 1.25C1.05078 1.25 0.876953 1.42578 0.876953 1.64062H0.875V8.35938H0.876953C0.876953 8.57422 1.05078 8.75 1.26367 8.75C1.34375 8.75 1.41016 8.72266 1.48242 8.68359L6.91406 5.45117C7.04297 5.34375 7.125 5.18164 7.125 5C7.125 4.81836 7.04297 4.6582 6.91406 4.54883Z'
        fill={color}
      />
    </g>
  </svg>
);
